import React from "react";
import { CheckIcon } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { images } from "../../i18n/translations";
import { Reveal } from "../ui/Reveal";
export function Machinery() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-slate-50 py-20 sm:py-28" data-id="element-177" data-mp="qk5jlf6fnwez">
      <div className="max-w-content mx-auto px-4 sm:px-6" data-id="element-178" data-mp="qikqzv3oinjr">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-179" data-mp="bmd6sus9tm4h">
          <div className="order-2 lg:order-1" data-id="element-180" data-mp="gly7par044ju">
            <Reveal data-id="element-181" data-mp="gmr35fkif7mo">
              <span className="inline-flex items-center gap-2 text-orange font-semibold text-sm uppercase tracking-[0.18em]" data-id="element-182" data-mp="gn9b39gjbaaf">
                <span className="h-px w-6 bg-orange" aria-hidden="true" data-id="element-183" data-mp="7l9swdtsa05w" />
                {t.machinery.eyebrow}
              </span>
              <h2 className="mt-3 font-heading font-bold uppercase text-navy text-3xl sm:text-4xl leading-[1.05]" data-id="element-184" data-mp="1wzy0m1rfitxl">
                {t.machinery.title}
              </h2>
              <p className="mt-5 text-slate-600 leading-relaxed" data-id="element-185" data-mp="1aa84umzyfi4s">{t.machinery.subtitle}</p>
            </Reveal>

            <ul className="mt-7 grid sm:grid-cols-2 gap-x-6 gap-y-3" data-id="element-186" data-mp="16966079y983c">
              {t.machinery.list.map(m => <li key={m} className="flex items-center gap-3" data-id="element-187" data-mp="1jyzuuplgfsd2">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-sm bg-orange text-white" data-id="element-188" data-mp="1f0yg2gv2af7e">
                    <CheckIcon size={15} data-id="element-189" data-mp="raucg9hvifge" />
                  </span>
                  <span className="text-navy font-medium" data-id="element-190" data-mp="rd6zh12hng0b">{m}</span>
                </li>)}
            </ul>
          </div>

          <Reveal className="order-1 lg:order-2" data-id="element-191" data-mp="119tjjnmzq31a">
            <img src={images.machinery} alt="Planta trituradora y equipos de producción de agregados" loading="lazy" className="w-full h-[380px] lg:h-[480px] object-cover rounded-sm shadow-xl" data-id="element-192" data-mp="117gu6pewkqe7" />
          </Reveal>
        </div>
      </div>
    </section>;
}